import api from './axios';

const BASE = '/offers';

export const getOffers = (page = 0, size = 10, filters = {}) =>
  api.get(BASE, { params: { page, size, ...filters } });

export const createOffer = (data) => api.post(BASE, data);

export const updateOffer = (id, data) => api.put(`${BASE}/${id}`, data);

export const toggleOffer = (id) => api.patch(`${BASE}/${id}/toggle-active`);

export const deleteOffer = (id) => api.delete(`${BASE}/${id}`);
